(function () {
  'use strict';

  var $ = function (selector, context) { return (context || document).querySelector(selector); };
  var $$ = function (selector, context) { return Array.prototype.slice.call((context || document).querySelectorAll(selector)); };
  var main = $('[data-product-main]');
  var form = main ? $('form[action*="/cart/add"]', main) : null;

  if (!form) return;

  var productData = { variants: [], options: [] };
  var productJson = $('[data-product-json]');
  try {
    if (productJson) productData = JSON.parse(productJson.textContent);
  } catch (error) {
    productData = { variants: [], options: [] };
  }

  var gallery = $('[data-product-gallery]');
  var mainImage = gallery ? $('[data-gallery-image]', gallery) : null;
  var galleryThumbnails = gallery ? $$('[data-gallery-thumb]', gallery) : [];

  galleryThumbnails.forEach(function (thumbnail) {
    thumbnail.addEventListener('click', function () {
      var nextSrc = thumbnail.dataset.imageSrc;
      var nextSrcset = thumbnail.dataset.imageSrcset;

      if (mainImage && nextSrc) {
        mainImage.removeAttribute('srcset');
        mainImage.src = nextSrc;
        if (nextSrcset) mainImage.srcset = nextSrcset;
        mainImage.alt = thumbnail.dataset.imageAlt || '';
      }

      galleryThumbnails.forEach(function (item) {
        item.classList.remove('is-active');
        item.setAttribute('aria-current', 'false');
      });
      thumbnail.classList.add('is-active');
      thumbnail.setAttribute('aria-current', 'true');
    });
  });

  var selectedOptions = {};

  function getCurrentVariant() {
    var optionValues = (productData.options || []).map(function (optionName) {
      return selectedOptions[optionName];
    });

    return (productData.variants || []).find(function (variant) {
      return (variant.options || []).every(function (optionValue, index) {
        return optionValue === optionValues[index];
      });
    }) || productData.variants[0];
  }

  function formatMoney(cents) {
    var config = window.SkineticConfig || {};
    var amount = (cents / 100).toLocaleString('en-GB', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return (config.moneyFormat || '£{{amount}}').replace(/\{\{\s*amount\s*\}\}/, amount);
  }

  function updateVariant() {
    var variant = getCurrentVariant();
    if (!variant) return;

    var idInput = $('[data-variant-id]', form);
    if (idInput) idInput.value = variant.id;

    $$('[data-pdp-price]').forEach(function (priceElement) {
      var priceMarkup = '<span>' + formatMoney(variant.price) + '</span>';
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        priceMarkup = '<span class="price--sale">' + formatMoney(variant.price) + '</span> <s class="price--was">' + formatMoney(variant.compare_at_price) + '</s>';
      }
      priceElement.innerHTML = priceMarkup;
    });

    var addButton = $('[data-add-btn]', form);
    if (addButton) {
      addButton.disabled = !variant.available;
      var addLabel = $('[data-add-label]', addButton);
      if (addLabel) addLabel.textContent = variant.available ? 'Add To Ritual' : 'Sold Out';
    }

    var stickyButton = $('[data-sticky-add]');
    if (stickyButton) stickyButton.dataset.variantId = variant.id;

    if (history.replaceState) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      history.replaceState({}, '', url.toString());
    }
  }

  $$('[data-option-value]', form).forEach(function (button) {
    if (button.getAttribute('aria-pressed') === 'true') selectedOptions[button.dataset.optionName] = button.dataset.optionValue;
    button.addEventListener('click', function () {
      selectedOptions[button.dataset.optionName] = button.dataset.optionValue;
      $$('[data-option-name="' + button.dataset.optionName + '"]', form).forEach(function (optionButton) {
        optionButton.setAttribute('aria-pressed', 'false');
      });
      button.setAttribute('aria-pressed', 'true');
      updateVariant();
    });
  });

  $$('[data-qty]', form).forEach(function (quantityControl) {
    var input = $('input', quantityControl);
    var minus = $('[data-qty-minus]', quantityControl);
    var plus = $('[data-qty-plus]', quantityControl);
    if (minus) minus.addEventListener('click', function () { input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1); });
    if (plus) plus.addEventListener('click', function () { input.value = (parseInt(input.value, 10) || 1) + 1; });
  });

  form.addEventListener('submit', function (event) {
    if (!window.SkineticAddToCart) return;
    event.preventDefault();
    var variant = getCurrentVariant();
    if (!variant) return;
    var quantityInput = $('[name="quantity"]', form);
    var quantity = parseInt(quantityInput ? quantityInput.value : '1', 10) || 1;
    window.SkineticAddToCart(variant.id, quantity, null, $('[data-add-btn]', form));
  });

  var stickyBar = $('[data-sticky-bar]');
  var buyRegion = $('[data-buy-region]');
  if (stickyBar && buyRegion && 'IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        stickyBar.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
      });
    }, { threshold: 0 });
    observer.observe(buyRegion);
  }

  updateVariant();
})();
